// extracted by mini-css-extract-plugin
export default {"tabsRoot":"zQitYTr1wkums5SGjEXw","container":"iNpuJ7UQxSw9hlFULUGW","listArea":"SjR2y65htgsyW9oNgDcs","editorWrapper":"FX_VAWOR1Cwa4H5cyT1a","list":"HvmGrcffRa04XoYnE8Kg"};